<ng-container *ngIf="messages.length > 0">
  <div class="sticky-top">
    <div class="row mt-3">
      <div class="col-12 col-md-12 offset-lg-2 col-lg-8">
        <ngb-alert
          *ngFor="let message of messages"
          type="danger"
          (closed)="onClose(message)"
        >
          <i class="bi bi-exclamation-triangle me-2"></i>
          {{ message }}
        </ngb-alert>
      </div>
    </div>
  </div>
</ng-container>
